import type { OurContext } from '../context';
import { buildStandardHeaders, request } from '../util/network';

export interface MerchantDetails {
  companyName: string;
  displayName: string;
  msn: string;
  logoUrl: string;
}

export async function getMerchantDetails(context: OurContext): Promise<MerchantDetails> {
  if (!context.claims) {
    throw new Error('No claims');
  }
  const headers = {
    'Cache-Control': 'no-store',
    Pragma: 'no-cache',
    ...buildStandardHeaders(context.apiSubscriptionId, context.apiAuth),
  };
  const response = await request(context.claims.url + '/merchant', 'GET', headers, undefined, 1);
  if (
    response?.status === 200 &&
    response.headers.get('Content-Type')?.indexOf('application/json') !== -1
  ) {
    const json: MerchantDetails = await response.json();
    return json;
  }
  throw response;
}
